import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthorizeGuard } from './authorize.guard';

import { authResolver } from './auth.resolver';
import { GridDesignerRoutes } from './modules/grid-designer/grid-designer-routing';


const routes: Routes = [
  {
    path: 'products',
    canActivate: [AuthorizeGuard],
    loadChildren: () => import('./modules/products/products.module').then((m) => m.ProductsModule),
    resolve: {data: authResolver}
  },
  {
    path: 'fabrics',
    canActivate: [AuthorizeGuard],
    loadChildren: () => import('./modules/fabrics/fabrics.module').then((m) => m.FabricsModule),
    resolve: {data: authResolver}
  },
  {
    path: 'admin',
    canActivate: [AuthorizeGuard],
    loadChildren: () => import('./modules/admin/admin.module').then((m) => m.AdminModule),
    resolve: {data: authResolver}
  },
  // {
  //   path: 'deploy',
  //   canActivate: [AuthorizeGuard],
  //   loadChildren: () => import('./modules/deploy/deploy.module').then((m) => m.DeployModule),
  //   resolve: {data: authResolver}
  // },
  {
    path: 'deploy',
    canActivate: [AuthorizeGuard],
    loadComponent: () => import('./modules/deployer/deploy-view/deploy-view.component').then((c) => c.DeployViewComponent),
    resolve: {data: authResolver}
  },
  {
    path: 'help',
    canActivate: [AuthorizeGuard],
    loadChildren: () => import('./modules/faq/faq.module').then((m) => m.FaqModule),
    resolve: {data: authResolver}
  },
  {
    path: 'manage-account',
    canActivate: [AuthorizeGuard],
    loadChildren: () => import('./modules/manage-account/manage-account.module').then((m) => m.ManageAccountModule),
    resolve: {data: authResolver}
  },
  {
    path: 'product-editor',
    canActivate: [AuthorizeGuard],
    loadChildren: () => import('./modules/product/product.module').then((m) => m.ProductModule),
    resolve: {data: authResolver}
  },
  {
    path: 'collections',
    canActivate: [AuthorizeGuard],
    loadChildren: () => import('./modules/collections/collections.module').then((m) => m.CollectionsModule),
    resolve: {data: authResolver}
  },
  {
    path: 'product-import',
    loadChildren: () => import('./modules/importer/importer.module').then((m) => m.ImporterModule),
    resolve: {data: authResolver}
  },
  {
    path: 'login',
    pathMatch: 'prefix',
    loadChildren: () => import('./modules/login/login.module').then((m) => m.LoginModule)
  },
  {
    path: 'setup-2fa',
    loadComponent: () => import('./modules/login/components/two-factor-setup/two-factor-setup.component').then(c => c.TwoFactorSetupComponent)
  },
  {
    path: 'verify-otp',
    loadComponent: () => import('./modules/login/components/otp-verification/otp-verification.component').then(c => c.OtpVerificationComponent)
  },
  {
    path: 'image-bank',
    canActivate: [AuthorizeGuard],
    loadChildren: () => import('./modules/image-database/image-database.module').then((m) => m.ImageDatabaseModule),
    resolve: {data: authResolver}
  },
  {
    path: 'grid-designer',
    canActivate: [AuthorizeGuard],
    children: GridDesignerRoutes,
    resolve: {data: authResolver}
  },

  {
    path: 'review',
    canActivate: [AuthorizeGuard],
    loadChildren: () => import('./modules/360-reviews/360-reviews.module').then((m) => m.ReviewsModule),
    resolve: {data: authResolver}
  },
  {
    path: 'my-notifications',
    canActivate: [AuthorizeGuard],
    loadComponent: () => import('./my-notifications/my-notifications.component').then((c) => c.MyNotificationsComponent),
    resolve: {data: authResolver}
  },
  {
    path: 'import',
    canActivate:[AuthorizeGuard],
    loadChildren: () => import('./modules/importer/importer.module').then((c) => c.ImporterModule),
    resolve: {data: authResolver}
  },
  {
    path: 'compare-product-lists',
    canActivate: [AuthorizeGuard],
    loadComponent: async () => (await import('./standalone/product-comparison/product-comparison.component')).ProductComparisonComponent,
    resolve: {data: authResolver}
  },
  {
    path: 'admin/user',
    canActivate: [AuthorizeGuard],
    loadChildren: () => import('./modules/user/user.module').then((m) => m.UserModule),
    resolve: {data: authResolver}
  },
  {
    path: 'admin/resend-all-reviews',
    loadComponent: async () => (await import('./standalone/send-all-reviews/send-all-reviews.component')).SendAllReviewsComponent,
    resolve: {data: authResolver},
    canActivate: [AuthorizeGuard]
  },
  {
    path: 'admin/user-groups',
    loadComponent: async () => (await import('./user-groups/user-groups.component')).UserGroupsComponent,
    resolve: {data: authResolver}
  },
  {
    path: 'admin/prompt-settings',
    loadComponent: () => import('./gpt-settings/gpt-settings.component').then((c) => c.GptSettingsComponent),
    canActivate: [AuthorizeGuard],
    resolve: {data: authResolver}
  },
  {
    path: 'raw-table-manager',
    canActivate: [AuthorizeGuard],
    loadComponent: async () => (await import('./raw-table-manager/raw-table-manager.component')).RawTableManagerComponent,
    resolve: {data: authResolver}
  },
  {
    path: 'amend-products',
    canActivate: [AuthorizeGuard],
    loadComponent: async () => (await import('./amend-products/amend-products.component')).AmendProductsComponent,
  },
  {
    path: 'log-handler',
    canActivate: [AuthorizeGuard],
    loadComponent: () => import('./logging-handler/logging-handler.component').then((c) => c.LoggingHandlerComponent)
  },
  {
    path: 'logger',
    redirectTo: 'log-handler'
  },
  // Don't lazyload root component
  {
    path: '',
    pathMatch: 'full',
    canActivate: [AuthorizeGuard],
    loadComponent: () => import('./modules/home/components/index/index.component').then(m => m.IndexComponent),
    resolve: {data: authResolver}
  },

  { path: '**', redirectTo: '/' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
